<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered"
        >{{ App.ModalPartnership.VERSION }} {{ version.version }}</span
      >
      <div class="close-button cursor-pointer" @click.stop="close()">
        <b-icon icon="close" />
      </div>
    </header>

    <main class="content-version">
      <section class="list">
        <article v-if="selectType('added').length" class="mb-20">
          <h1 class="has-text-weight-medium">
            {{ App.Version.NEW_FUNCTIONALITIES }}:
          </h1>

          <div
            v-for="(item, index) in selectType('added')"
            :key="`added_${index}`"
            class="ml-10"
          >
            - {{ item.description }}
          </div>
        </article>

        <article
          v-if="selectType('improvement').length || selectType('fixed').length"
          class="mb-20"
        >
          <h1 class="has-text-weight-medium">
            {{ App.Version.IMPROVEMENTS_AND_FIXES }}:
          </h1>

          <div
            v-for="(item, index) in selectType('improvement')"
            :key="`improvement_${index}`"
            class="ml-10"
          >
            - {{ item.description }}
          </div>

          <div
            v-for="(item, index) in selectType('fixed')"
            :key="`fixed_${index}`"
            class="ml-10"
          >
            - {{ item.description }}
          </div>
        </article>
      </section>

      <a
        v-if="!version.old"
        href="/versoes"
        target="_blank"
        rel="help"
        class="link"
        >{{ App.Version.VIEW_HISTORY }}</a
      >
    </main>
  </div>
</template>

<script>
import { App } from "@/utils/constants";

export default {
  name: "ModalVersionDetail",

  props: {
    version: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      App
    };
  },

  methods: {
    close() {
      this.$parent.close();
    },
    selectType(type) {
      return this.version.items.filter(item => item.type === type);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  width: 756px;
  max-height: 75vh;
  max-width: 100%;
  background-color: $color-1;
  color: $color-7;
  @media screen and (max-width: $fullhd) {
    width: 650px;
    height: auto;
  }
}
.content-version {
  margin: 25px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .list {
    overflow-y: auto;
    max-height: 30vh;
  }
  .link {
    color: $color-12;
    margin-top: 25px;
    text-decoration: underline;
    font-weight: 600;
    width: fit-content;

    &:hover {
      color: $dark-white;
    }
  }
}
</style>
